import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QuestBuilderPage from './pages/QuestBuilderPage';
import DialogBuilderPage from './pages/DialogBuilderPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/quest-builder" element={<QuestBuilderPage />} />
        <Route path="/dialog-builder" element={<DialogBuilderPage />} />
      </Routes>
    </Router>
  );
}

export default App;
